import { h } from 'preact';
export default function DiscardButton(_ref) {
  let {
    onDiscard,
    i18n
  } = _ref;
  return h("button", {
    className: "uppy-u-reset uppy-c-btn uppy-ScreenCapture-button uppy-ScreenCapture-button--discard",
    type: "button",
    title: i18n('discardMediaFile'),
    "aria-label": i18n('discardMediaFile'),
    onClick: onDiscard,
    "data-uppy-super-focusable": true
  }, h("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, h("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), h("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })));
}